import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { uniq } from 'lodash';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../../core/settings';
import { ProtocolsReadModel, Protocol } from '../../../admin/shared/protocol';
import { EmailSearchFieldReadModel } from '../../e-query/models/e-query-escalation-search-field';

@Injectable()
export class AdminProtocolAccessSearchFieldsStorage {
    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings,
    ) {}

    public loadEmails(term: string): Observable<string[]> {
        return this.searchUserEmail(term, res => deserialize(res, EmailSearchFieldReadModel).searchFields, x => x.email);
    }

    public loadProtocol(term: string): Observable<Protocol[]> {
        return this.searchProtocol(term, res => deserialize(res, ProtocolsReadModel).protocols, x => x);
    }

    public searchProtocol<T, TResult>(
        term: string,
        deserializerFn: (res: Object) => T[],
        fieldFn: (x: T) => TResult,
    ): Observable<TResult[]> {
        return this.http.get(`${this.settings.apiUrl}/admin/protocols`, { params: { term } })
            .pipe(
                map(res => {
                    const searchFields = deserializerFn(res);
                    return uniq(searchFields.map(fieldFn));
                })
            );
    }

    public searchUserEmail<T, TResult>(
        searchTerm: string,
        deserializerFn: (res: Object) => T[],
        fieldFn: (x: T) => TResult,
    ): Observable<TResult[]> {
        return this.http.get(`${this.settings.apiUrl}/admin/activity-reports/protocol-accesses/users/search`, { params: { searchTerm } })
            .pipe(
                map(res => {
                    const searchFields = deserializerFn(res);
                    return uniq(searchFields.map(fieldFn));
                })
            );
    }
}